import type { CardFaceProps } from './types';
import styles from './ArtCard.module.css';

// Ultrahuman mark, cropped to its bounds so it fills the design's 4.9 × 3.6cqw box.
const MARK =
  'M23.9866 9H9.01343V14.3976H12.0194L7 19.008L10.6866 23L16.4716 17.7711L22.3134 23L26 19.008L20.9522 14.3976H23.9866V9Z';

/** Amount, logo and label printed on an illustrated or pattern card. */
export const ArtCardFace = ({ title, subtitle, amount }: CardFaceProps) => (
  <>
    <svg className={styles.logo} viewBox="7 9 19 14" aria-hidden="true">
      <path d={MARK} />
    </svg>
    <div className={styles.label}>
      {amount && <span className={styles.amount}>{amount}</span>}
      <span className={styles.l1}>{title}</span>
      <span className={styles.l2}>{subtitle}</span>
    </div>
  </>
);
